
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leadership/[slug]",
      function () {
        return require("private-next-pages/leadership/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leadership/[slug]"])
      });
    }
  